import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import { DeleteContactModal as _DeleteContactModal } from "routes/entity/components/Modals";
import { useContactNavigation } from "routes/contact/useContactNavigation";

const EDIT_ACLS = [
  ACL_RELATIONSHIPS.entityContact.edit,
  ACL_RELATIONSHIPS.entityForFilters.read,
];

const DeleteContactModal = withRoleCheck(_DeleteContactModal, [
  ACL_RELATIONSHIPS.entityContact.delete,
]);

export function ContactTableActions({ contact, handleDeleteContact }) {
  const { openEdit } = useContactNavigation();

  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction="left">
        <Authorized permissions={EDIT_ACLS}>
          <Dropdown.Item
            icon="edit"
            content="Edit"
            onClick={() => openEdit(contact.id)}
          />
        </Authorized>
        <DeleteContactModal
          onConfirmDelete={() =>
            handleDeleteContact(contact.entity_id, contact.id)
          }
          menuTrigger
        />
      </Dropdown.Menu>
    </CustomDropdown>
  );
}
